"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  name: {
    "id": "licenses.name",
    "defaultMessage": "Name"
  },
  version: {
    "id": "licenses.version",
    "defaultMessage": "Version"
  },
  downloadLicenseFiles: {
    "id": "licenses.downloadLicenseFiles",
    "defaultMessage": "Download license files"
  },
  aZipFileWillBeDownloaded: {
    "id": "licenses.aZipFileWillBeDownloaded",
    "defaultMessage": "A zip file which contains various files (e.g. license file, readme, recipe info, etc.) will be downloaded."
  },
  selectAFileToDownload: {
    "id": "licenses.selectAFileToDownload",
    "defaultMessage": "Select a file to download"
  },
  download: {
    "id": "licenses.download",
    "defaultMessage": "Download"
  }
});
exports.messages = messages;
//# sourceMappingURL=licenses-i18n.js.map